var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-link',{staticClass:"SidebarToggleButton text-secondary",on:{"click":function($event){return _vm.$emit('input', !_vm.collapsed)}}},[_c('img',{attrs:{"src":_vm.src,"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }